import React, { useState, useEffect } from "react";
import {
  makeStyles,
  Paper,
  Grid,
  Table,
  TableHead,
  TableBody,
  TableCell,
  TableRow,
  IconButton,
  Button,
} from "@material-ui/core";
import ConfirmationModal from "../ConfirmationModal";
import useTableStyles from "../TableStyles";
import MainHeader from "../MainHeader";
import MainHeaderButtonsWrapper from "../MainHeaderButtonsWrapper";
import Title from "../Title";
import CompanyFormModal from "../CompanyFormModal";

import { Edit as EditIcon } from "@material-ui/icons";
import { Add as AddIcon } from "@material-ui/icons";

import { toast } from "sonner";
import useCompanies from "../../hooks/useCompanies";
import { useDate } from "../../hooks/useDate";

import moment from "moment";
import { i18n } from "../../translate/i18n";

const useStyles = makeStyles((theme) => ({
  root: {
    width: "100%",
  },
  mainPaper: {
    width: "100%",
    flex: 1,
    padding: theme.spacing(2, 3),
  },
  fullWidth: {
    width: "100%",
  },
  textfield: {
    width: "100%",
    "& .MuiOutlinedInput-root": {
      borderRadius: 10,
      fontFamily: '"Inter", "Poppins", sans-serif',
      "& fieldset": {
        borderColor: theme.palette.type === "dark" ? "rgba(255,255,255,0.12)" : "#E2E8F0",
      },
      "&:hover fieldset": {
        borderColor: theme.palette.type === "dark" ? "rgba(255,255,255,0.2)" : "#CBD5E1",
      },
      "&.Mui-focused fieldset": {
        borderColor: "#35af9a",
      },
    },
    "& .MuiInputLabel-outlined": {
      fontFamily: '"Inter", "Poppins", sans-serif',
      "&.Mui-focused": {
        color: "#35af9a",
      },
    },
  },
  selectContainer: {
    width: "100%",
    "& .MuiOutlinedInput-root": {
      borderRadius: 10,
      fontFamily: '"Inter", "Poppins", sans-serif',
      "& fieldset": {
        borderColor: theme.palette.type === "dark" ? "rgba(255,255,255,0.12)" : "#E2E8F0",
      },
      "&:hover fieldset": {
        borderColor: theme.palette.type === "dark" ? "rgba(255,255,255,0.2)" : "#CBD5E1",
      },
      "&.Mui-focused fieldset": {
        borderColor: "#35af9a",
      },
    },
    "& .MuiInputLabel-outlined": {
      fontFamily: '"Inter", "Poppins", sans-serif',
      "&.Mui-focused": {
        color: "#35af9a",
      },
    },
    "& .MuiSelect-select": {
      fontFamily: '"Inter", "Poppins", sans-serif',
    },
  },
  addButton: {
    borderRadius: 10,
    fontFamily: '"Inter", "Poppins", sans-serif',
    fontWeight: 600,
    fontSize: 14,
    padding: "8px 16px",
    color: theme.palette.type === "dark" ? "#E2E8F0" : "#1E293B",
    backgroundColor: "transparent",
    boxShadow: "none",
    border: theme.palette.type === "dark"
      ? "1px solid rgba(255,255,255,0.12)"
      : "1px solid #E2E8F0",
    "&:hover": {
      backgroundColor: theme.palette.type === "dark"
        ? "rgba(255,255,255,0.04)"
        : "#F8FAFC",
      boxShadow: "none",
    },
  },
}));


export function CompaniesManagerGrid(props) {
  const { records, onSelect } = props;
  const classes = useStyles();
  const tableClasses = useTableStyles();
  const { dateToClient, datetimeToClient } = useDate();

  const renderStatus = (row) => {
    return row.status === false ? "Não" : "Sim";
  };

  const renderPlan = (row) => {
    return row.planId !== null ? row.plan.name : "-";
  };

  const renderPlanValue = (row) => {
    return row.planId !== null ? row.plan.amount ? row.plan.amount.toLocaleString('pt-br', { minimumFractionDigits: 2 }) : '00.00' : "-";
  };

  // const renderCampaignsStatus = (row) => {
  //   if (
  //     has(row, "settings") &&
  //     isArray(row.settings) &&
  //     row.settings.length > 0
  //   ) {
  //     const setting = row.settings.find((s) => s.key === "campaignsEnabled");
  //     if (setting) {
  //       return setting.value === "true" ? "Habilitadas" : "Desabilitadas";
  //     }
  //   }
  //   return "Desabilitadas";
  // };

  const rowStyle = (record) => {
    if (moment(record.dueDate).isValid()) {
      const now = moment();
      const dueDate = moment(record.dueDate);
      const diff = dueDate.diff(now, "days");
      if (diff >= 1 && diff <= 5) {
        return { backgroundColor: "#fffead" };
      }
      if (diff <= 0) {
        return { backgroundColor: "#fa8c8c" };
      }
      // else {
      //   return { backgroundColor: "#affa8c" };
      // }
    }
    return {};
  };

  return (
    <Paper className={tableClasses.tableContainer} elevation={0}>
      <Table
        className={classes.fullWidth}
        padding="normal"
        aria-label="companies table"
      >
        <TableHead className={tableClasses.tableHead}>
          <TableRow>
            <TableCell className={tableClasses.tableHeadCell} align="center" style={{ width: "1%" }}>#</TableCell>
            <TableCell className={tableClasses.tableHeadCell} align="left">{i18n.t("compaies.table.name")}</TableCell>
            <TableCell className={tableClasses.tableHeadCell} align="left">{i18n.t("compaies.table.email")}</TableCell>
            <TableCell className={tableClasses.tableHeadCell} align="center">{i18n.t("compaies.table.phone")}</TableCell>
            <TableCell className={tableClasses.tableHeadCell} align="center">{i18n.t("compaies.table.plan")}</TableCell>
            <TableCell className={tableClasses.tableHeadCell} align="center">{i18n.t("compaies.table.value")}</TableCell>
            <TableCell className={tableClasses.tableHeadCell} align="center">{i18n.t("compaies.table.active")}</TableCell>
            <TableCell className={tableClasses.tableHeadCell} align="center">{i18n.t("compaies.table.createdAt")}</TableCell>
            <TableCell className={tableClasses.tableHeadCell} align="center">{i18n.t("compaies.table.dueDate")}</TableCell>
            <TableCell className={tableClasses.tableHeadCell} align="center">{i18n.t("compaies.table.lastLogin")}</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {records.map((row, key) => (
            <TableRow className={tableClasses.tableRow} style={rowStyle(row)} key={key}>
              <TableCell className={tableClasses.tableCell} align="center" style={{ width: "1%" }}>
                <IconButton 
                  onClick={() => onSelect(row)} 
                  aria-label="edit"
                  className={tableClasses.actionButton}
                  size="small"
                >
                  <EditIcon fontSize="small" />
                </IconButton>
              </TableCell>
              <TableCell className={tableClasses.tableCell} align="left">{row.name || "-"}</TableCell>
              <TableCell className={tableClasses.tableCell} align="left">{row.email || "-"}</TableCell>
              <TableCell className={tableClasses.tableCell} align="center">{row.phone || "-"}</TableCell>
              <TableCell className={tableClasses.tableCell} align="center">{renderPlan(row)}</TableCell>
              <TableCell className={tableClasses.tableCell} align="center">{i18n.t("compaies.table.money")} {renderPlanValue(row)}</TableCell>
              <TableCell className={tableClasses.tableCell} align="center">{renderStatus(row)}</TableCell>
              <TableCell className={tableClasses.tableCell} align="center">{dateToClient(row.createdAt)}</TableCell>
              <TableCell className={tableClasses.tableCell} align="center">{dateToClient(row.dueDate)}<br /><span>{row.recurrence}</span></TableCell>
              <TableCell className={tableClasses.tableCell} align="center">{datetimeToClient(row.lastLogin)}</TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </Paper>
  );
}

export default function CompaniesManager() {
  const classes = useStyles();
  const { list, save, update, remove } = useCompanies();

  const [showConfirmDialog, setShowConfirmDialog] = useState(false);
  const [modalOpen, setModalOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [records, setRecords] = useState([]);
  const [editingCompany, setEditingCompany] = useState(null);

  useEffect(() => {
    loadCompanies();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const loadCompanies = async () => {
    setLoading(true);
    try {
      const companyList = await list();
      setRecords(companyList);
    } catch (e) {
      toast.error("Não foi possível carregar a lista de registros");
    }
    setLoading(false);
  };

  const handleOpenModal = () => {
    setEditingCompany(null);
    setModalOpen(true);
  };

  const handleCloseModal = () => {
    setModalOpen(false);
    setEditingCompany(null);
  };

  const handleSubmit = async (data) => {
    setLoading(true);
    try {
      if (data.id !== undefined) {
        await update(data);
      } else {
        await save(data);
      }
      await loadCompanies();
      handleCloseModal();
      toast.success("Operação realizada com sucesso!");
    } catch (e) {
      toast.error(
        "Não foi possível realizar a operação. Verifique se já existe uma empresa com o mesmo nome ou se os campos foram preenchidos corretamente"
      );
    }
    setLoading(false);
  };

  const handleDelete = async (company) => {
    setLoading(true);
    try {
      await remove(company.id);
      await loadCompanies();
      handleCloseModal();
      toast.success("Operação realizada com sucesso!");
    } catch (e) {
      toast.error("Não foi possível realizar a operação");
    }
    setLoading(false);
  };

  const handleOpenDeleteDialog = (company) => {
    setEditingCompany(company);
    setShowConfirmDialog(true);
  };

  const handleConfirmDelete = async () => {
    setShowConfirmDialog(false);
    await handleDelete(editingCompany);
  };

  const handleSelect = (data) => {
    setEditingCompany({
      id: data.id,
      name: data.name || "",
      phone: data.phone || "",
      email: data.email || "",
      planId: data.planId || "",
      status: data.status === false ? false : true,
      dueDate: data.dueDate || "",
      recurrence: data.recurrence || "",
      password: "",
      document: data.document || "",
      paymentMethod: data.paymentMethod || "",
    });
    setModalOpen(true);
  };

  return (
    <Paper className={classes.mainPaper} elevation={0}>
      <MainHeader>
        <Title>{i18n.t("compaies.title") || "Empresas"}</Title>
        <MainHeaderButtonsWrapper>
          <Button
            variant="outlined"
            startIcon={<AddIcon />}
            onClick={handleOpenModal}
            className={classes.addButton}
          >
            Cadastrar Empresa
          </Button>
        </MainHeaderButtonsWrapper>
      </MainHeader>
      <Grid spacing={2} container style={{ marginTop: 16 }}>
        <Grid xs={12} item>
          <CompaniesManagerGrid records={records} onSelect={handleSelect} />
        </Grid>
      </Grid>
      <CompanyFormModal
        open={modalOpen}
        onClose={handleCloseModal}
        initialValue={editingCompany}
        onSubmit={handleSubmit}
        onDelete={handleOpenDeleteDialog}
        loading={loading}
      />
      <ConfirmationModal
        title="Exclusão de Registro"
        open={showConfirmDialog}
        onClose={() => {
          setShowConfirmDialog(false);
          setEditingCompany(null);
        }}
        onConfirm={handleConfirmDelete}
      >
        Deseja realmente excluir esse registro?
      </ConfirmationModal>
    </Paper>
  );
}
